import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { PresignService } from '../../../services/presign.service';
import { PurchaseOrders } from '../../../services/purchase-orders.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-upload-purchase-order-modal',
  imports: [CommonModule],
  templateUrl: './upload-purchase-order-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class UploadPurchaseOrderModal { 
  @Output() close = new EventEmitter<void>();
  @Output() fileUploaded = new EventEmitter<File>();

  xlsFile: File | null = null;
  isUploading = false;

  constructor( 
    private presign: PresignService,
    private purchaseService: PurchaseOrders
  ){}

  get fileName() {
    return this.xlsFile?.name ?? null;
  }

  private sanitizeFileName ( file: File ): File {
    const cleanName = file.name.replace(/\s+/g, '_');
    if (cleanName === file.name) return file;
    return new File([file], cleanName, {type: file.type});
  }

  onFileSelected( event: Event ) { 
    const input = event.target as HTMLInputElement;
    if (input.files?.length){
      let file = input.files[0];
      file = this.sanitizeFileName(file);
      this.xlsFile = file;
    }
  }

  async uploadFile() { 
    if(!this.xlsFile){
      console.warn('Recuerde subir el archivo para continuar');
      return;
    }

    const uuid = localStorage.getItem('uuid_cfdi');
    if (!uuid) {
      alert('No existe un UUID asociado.');
      return;
    }

    this.isUploading = true;

    try {
      const folder = uuid;
      const filename = this.xlsFile.name;
      const bucket = 'DOC';

      const signedUrlResponse = await this.presign.getPresignedUrl(folder, filename, bucket);
      await this.presign.uploadFileToS3(signedUrlResponse.uploadUrl, this.xlsFile);

      this.fileUploaded.emit(this.xlsFile);
      this.close.emit();

    } catch(error) {
      console.error('Error al subir la orden de compra', error);
      
    } finally {
      this.isUploading = false;
    }
  }
}